import Focus3LineIcon from "remixicon-react/Focus3LineIcon";
import { useDispatch } from "react-redux";
import { setCurrentStep } from "../../../redux";
import { steps } from "../../../util/constants";
import { Button } from "antd";
import { iconSize } from "../../../config";

export const AdjustPlacementButton = () => {
  const dispatch = useDispatch();
  const editLocations = () =>
    dispatch(setCurrentStep(steps.configureLocations));
  return (
    <Button
      onClick={editLocations}
      type="text"
      icon={<Focus3LineIcon size={iconSize} />}
    >
      Adjust placement
    </Button>
  );
};
